export default __webpack_public_path__ + "static/media/sigma.9f8919aa.PNG";